import { Component, OnInit } from '@angular/core';
import {AuthenticationService} from "../services/authentication.service";

@Component({
  selector: 'app-recoverypass',
  templateUrl: './recoverypass.component.html',
  styleUrls: ['./recoverypass.component.css']
})
export class RecoverypassComponent implements OnInit {
  email: string = null;
  error_message: string = '';
  success_message: string = '';

  constructor(private auth_service: AuthenticationService) { }

  ngOnInit() {
  }
  resetPassword(){
    if(this.email != null){
      this.auth_service.resetPassword(this.email).then(
        () => {
          this.success_message = '1s-Recuperar Contraseña: Correo electrónico para recuperar enviado';
        }).catch(
        (error) => {
          switch (error.code) {
            case 'auth/invalid-email':
              this.error_message = '2e-Recuperar Contraseña: Correo no regitrado o no valido';
              break;
          }
          console.log('Error Mensaje: ' + error.message);
          console.log('Error Código: ' + error.code);
        });
    }else{
      this.error_message = '1e-Recuperar Contraseña: Ingrese un correo';
    }
  }

}
